import React, { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import {Link, useParams} from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

class GalleryItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data      :[],
      isLoading :true,
      show      :false
    };
  }

  async getGallery(albumId) {
    try {
      const url = `/api/photo_gallery/${albumId}`;
      const response = await fetch(url);
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    const albumId = this.props.albumId;
    this.getGallery(albumId);
  }

  render() {
    if(!this.state.isLoading){
      const gallery = this.state.data;

      const photo_gallery = gallery.map((item)=>{
        var images = {
          original : item.img_url,
          thumbnail: item.img_url,
          originalHeight: 300,
          originalWidth : 'auto',
          loading : 'lazy',
          thumbnailLoading: 'lazy',
          originalAlt   : item.title,
          thumbnailAlt  : item.title,
          originalTitle : item.title
        }
        return images
      });
      return(
          <>
            <Link to="/albums" className="btn btn-sm btn-primary ms-2"><i className="fas fa-arrow-left"></i> Go back to albums</Link>
            <div className="d-flex">
              <div className="my-2 pt-3 px-2 photo_gallery">
                <ImageGallery
                 items={photo_gallery}
                 lazyLoad={true}
                 autoPlay={true}
                />
              </div>
            </div>
          </>
      );
    }
  }
}

function Gallery() {
  let { albumId } = useParams();
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <GalleryItemList albumId={albumId} />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { Gallery };
